<template>
  <section :id class="container">
    <div v-if="isEditing">
      <div>Dynamics 365 Form placeholder.</div>
    </div>
    <div v-else :key="language + firstId + secondId + apiType">
      <ClientOnly>
        <LazyDynamicsFormLegacy
          v-if="firstId && secondId"
          :dynamics-form-id="firstId"
          :dynamics-id="secondId"
        />
        <LazyDynamicsFormRealtime
          v-else-if="firstId"
          :form-id="firstId"
          :event-id="eventId"
          :api-type="apiType"
        />
      </ClientOnly>
    </div>
  </section>
</template>

<script lang="ts" setup>
/**
 * This paragraphs supports both the "legacy" and the real-time form.
 * The legacy form must provide both IDs, the real-time form only the first ID.
 */
defineProps<{
  firstId?: string
  secondId?: string
  eventId?: string
  apiType?: string
}>()

const { isEditing, index, siblings } = defineBlokkli({
  bundle: 'dynamics_365',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
const language = useCurrentLanguage()
</script>
